import React from 'react';

const styles = {
  base: {
    backgroundColor: 'rgba(15, 23, 42, 0.6)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.05)',
    borderRadius: '16px',
    padding: '32px',
    transition: 'all 0.3s ease',
    position: 'relative',
  },
  highlighted: {
    border: '1px solid rgba(59, 130, 246, 0.3)',
    boxShadow: '0 0 40px rgba(59, 130, 246, 0.1)',
  },
  scaled: {
    transform: 'scale(1.02)',
  },
};

export const Card = ({
  children,
  highlighted = false,
  scaled = false,
  style = {},
  className = '',
  onMouseEnter,
  onMouseLeave,
  ...props
}) => {
  const cardStyle = {
    ...styles.base,
    ...(scaled ? styles.scaled : {}),
    ...style,
  };

  const premiumClass = highlighted
    ? 'card-premium card-premium-highlighted'
    : 'card-premium';

  return (
    <div
      style={cardStyle}
      className={`${premiumClass} ${className}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...props}
    >
      {children}
    </div>
  );
};
